import { SingleAnalysisItem } from "@components/pipelineNodes/PipelineNodeList.component";
import { DraftOnly } from "@components/project/DraftModeRequired.component";
import { useAnalyses } from "@models/analysis";
import PageStructure, { PageContent, PageContentHeader, PageContentInner, Pane, PaneContent } from "@pages/PageStructure.component";
import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const AnalysisListPage = () => {
    const [search, setSearch] = useState('');
    const { data: analyses } = useAnalyses();
    const navigate = useNavigate();

    const filteredAnalyses = useMemo(() => {
        if (!analyses) return [];
        return analyses
            .filter(analysis => 
                analysis.name.toLowerCase().includes(search.toLowerCase()) ||
                analysis.description?.toLowerCase().includes(search.toLowerCase())
            )
            .sort((a, b) => {
                // Sort by last_updated, most recent first
                const dateA = a.last_updated ? new Date(a.last_updated) : new Date(0);
                const dateB = b.last_updated ? new Date(b.last_updated) : new Date(0);
                return dateB.getTime() - dateA.getTime();
            });
    }, [analyses, search]);

    return <PageStructure>
        <PageContent>
            <PageContentHeader>
                <div className="d-flex center-vertically">
                    <div style={{width:'40%'}}>
                        <h1 className="mb-0">Charts</h1>
                        <div className="text-muted font-13">Create charts and tables to analyze your data.</div>
                    </div>
                    <div className="flex-1 ps-5 pe-5">
                        <input 
                            type="text" 
                            className="form-control input-rounded input-search" 
                            placeholder="Search..." 
                            value={search} 
                            onChange={e => setSearch(e.target.value)}
                        />
                    </div>
                    <div>
                        <Link to="/charts/new" className="btn btn-primary">
                            <i className="mdi mdi-plus-thick"></i> New Chart
                        </Link>
                    </div>
                </div>
            </PageContentHeader>
            <PageContentInner hasHeader>
                <Pane>
                    <PaneContent>
                        <div className="p-4">
                            <div className="row g-3">
                                {filteredAnalyses.map(analysis => (
                                    <div key={analysis.id} className="col-4">
                                        <SingleAnalysisItem
                                            analysis={analysis}
                                            rounded
                                            onClick={() => navigate(`/charts/${analysis.id}`)}
                                        />
                                    </div>
                                ))}
                                {filteredAnalyses.length === 0 && (
                                    <div className="col-12 text-center text-muted py-5">
                                        {search ? (
                                            <>
                                                <i className="mdi mdi-file-search font-24 mb-2 d-block"></i>
                                                <p>No charts match your search.</p>
                                            </>
                                        ) : (
                                            <>
                                                <i className="mdi mdi-chart-box font-24 mb-2 d-block"></i>
                                                <p>No charts yet. Create your first chart to get started.</p>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </PaneContent>
                </Pane>
            </PageContentInner>
        </PageContent>
    </PageStructure>
};

export default AnalysisListPage;